// Story 1.22 — rendered when GET /api/v1/creators/me returns
// 403 CREATOR_PROFILE_FORBIDDEN with reason="suspended".
//
// At v1 there's no UI for un-suspending — admin support handles it
// manually. Story 1.27 ships the admin-driven suspend/reinstate flow.

import { Card, CardContent, CardHeader, CardTitle } from "@greenhold/components";

export function SuspendedCard() {
  return (
    <Card className="max-w-xl mx-auto">
      <CardHeader>
        <CardTitle>Your creator status is suspended</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p>
          We've paused your creator profile. Profile edits, image uploads, and
          new applications are blocked until the situation is resolved.
        </p>
        <p>
          For help, email{" "}
          <a
            href="mailto:support@greenhold.world"
            className="underline decoration-dotted"
          >
            support@greenhold.world
          </a>
          .
        </p>
      </CardContent>
    </Card>
  );
}
